<template>
  <div id="tempcreate-layer">
    <light-header :back="backUrl"></light-header>
    <div class="tempcreate-content auto" v-loading="formLoading">
      <div class="tempcreate-files">
        <h3 class="tempcreate-title">
          <span>个人实名认证</span>
        </h3>
        <el-form
          :model="filesForm"
          :rules="filesRules"
          ref="filesForm"
          label-width="220px"
          label-position="right"
          class="files-Form"
        >
          <div style="display: flex; flex-wrap: wrap" id="company-info-layer">
            <div style="width: 100%">
              <div style="padding: 0 0 15px; width: 90%; margin: 0 auto">
                <el-divider content-position="center"
                  >根据《中华人民共和国电子签名法》要求签署方身份信息真实，请您完成个人认证，如没有完成个人实名认证将不能签署合同。</el-divider
                >
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="tempcreate-users-box auto">
      <div class="sign-btns">
        <el-button
          type="primary"
          @click="handleSaveCompanyInfo"
          :disabled="formLoading"
          >提 交</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
// import { Loading } from "element-ui";
import { mapState } from "vuex";
import { getToken, getConsoleUrl } from "@/utils/auth";
import { contractTemplateImgApi } from "@/api/template/index";
import { getDraftInfo } from "@/api/sign/sign";
import {
  authorizationAddressPath,
  submitCompanyAuthInfo,
} from "@/api/auth/auth";
import { parseTime, downloadFile } from "@/utils/index";
import lightHeader from "@/components/lightHeader";

export default {
  components: {
    lightHeader,
  },
  computed: {
    ...mapState(["companyList", "currentSpace", "userInfo"]),
    isUser() {
      return this.$route.query.isuse == 1 ? true : false;
    },
    uploadData() {
      if (this.currentSpace) {
        return { companyId: this.currentSpace.companyId };
      } else {
        return { companyId: "" };
      }
    },
    backUrl() {
      if (this.$route.query.from) {
        return this.$route.query.from.replace(/\!\!/g, "?");
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      formLoading: false,

      filesForm: {
        companyType: "company",
        legalBackImgFileId: "",
        legalFrontImgFileId: "",
        licenseImgFileId: "",
        authFileImgFileId: "",
        agentFrontImgFileId: "",
        agentBackImgFileId: "",
      },

      checkID: (rule, value, callback) => {
        let idcard_patter =
          /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/;
        if (!idcard_patter.test(value)) {
          callback(new Error("身份证号输入有误！"));
        } else {
          callback();
        }
      },
      checkChinese: (rule, value, callback) => {
        var reg = /^[\u0391-\uFFE5]+$/;
        if (!reg.test(value)) {
          callback(new Error("只能输入中文！"));
        } else {
          callback();
        }
      },
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.tempcreate-content {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  margin-top: 30px;

  .tempcreate-files {
    background: #ffffff;
    overflow: hidden;
    padding: 27px 27px;
    .tempcreate-title {
      height: 23px;
      line-height: 23px;
      font-size: 18px;
      color: #333333;
      border-left: 3px solid #3296fa;
      text-indent: 10px;
      font-weight: 400;
      margin-bottom: 22px;
    }
    label {
      width: 98px;
      color: #666666;
      display: inline-block;
    }
  }
}
.tempcreate-users-box {
  padding: 15px 40px;
  background: #ffffff;
  margin-top: 18px;

  .add-btn {
    padding: 11px 14px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color: #ffffff;
  }

  .sign-btns button.sign-button {
    padding: 12px 18px;
    background: #3296fa;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
  }
}
#tempcreate-layer {
  background: #f0f0f5;
  min-height: 100vh;
}

// .tempcreate-content {
// 	width: 1200px;
// 	margin: 30px auto;
// }

.sign-btns {
  width: 718px;
  margin: 20px auto 0;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}

.sign-btns button {
  width: 140px;
  height: 45px;
  font-size: 14px;
}

#invoice-info-layer .el-form-item /deep/ .el-input__inner,
#invoice-info-layer .el-form-item /deep/ .el-form-item__content,
#invoice-info-layer .el-form-item /deep/ .el-date-editor,
#company-info-layer .el-form-item /deep/ .el-input__inner,
#company-info-layer .el-form-item /deep/ .el-form-item__content,
#company-info-layer .el-form-item /deep/ .el-date-editor {
  width: 300px !important;
}

h4 {
  padding: 10px 0 30px;
  text-align: center;
}
.el-divider /deep/ .el-divider__text {
  color: #999;
  text-align: center;
}

#auth-info-company-layer .el-form-item__label {
  font-size: 18px;
  line-height: 48px;
}

#auth-info-company-layer .submit {
  width: 363px;
  height: 50px;
  margin: 60px auto 0;
  font-size: 18px;
  margin-bottom: 96px;
}

#auth-info-company-layer .el-form-item {
  width: 55%;
  margin: 0 auto 20px;
}

#auth-info-company-layer .el-form-item /deep/ .el-form-item__label {
  width: 100% !important;
  text-align: center;
}
</style>